import { ForwardTradeChangeRequestModalProps } from "./forward-trade-change-request-modal.types";
import { ForwardTradeChangeRequestModalView } from "./forward-trade-change-request-modal-view";
import { useForwardTradeChangeRequestModal } from "./use-forward-trade-change-request-modal";

export const ForwardTradeChangeRequestModal = (props: ForwardTradeChangeRequestModalProps) => {
  const logic = useForwardTradeChangeRequestModal(props);

  return <ForwardTradeChangeRequestModalView {...logic} {...props} />;
};
